import {SalesDto} from "../sales/sales-dto";

export class SalesDataCacheVO {
  dataCache: { [K in keyof SalesDto]: { id: string, value: number }[] } = {
    id: [],
    locationId: [],
    timeInterval: [],
    compositionTypeId: [],
    orderId: [],
    pricePerUnit: [],
    quantity: [],
    compositionId: [],
    compositionCompositeId: [],
    compositionVariantKey: [],
    compositionName: [],
    modificationLines: [],
    bookingType: [],
    hasSpecialTag: [],
    isActive: [],
    sourceDetailsCost: [],
    revenueAfterTax: []
  };

  public generateCache(salesDtoList: SalesDto[], keys: (keyof SalesDto)[], valueFn: (salesDto: SalesDto) => number): void {
    let cache: { [id in keyof SalesDto]: { [id: string]: number } } = {
      id: {},
      locationId: {},
      timeInterval: {},
      compositionTypeId: {},
      orderId: {},
      pricePerUnit: {},
      quantity: {},
      compositionId: {},
      compositionCompositeId: {},
      compositionVariantKey: {},
      compositionName: {},
      modificationLines: {},
      isActive: {},
      hasSpecialTag: {},
      sourceDetailsCost: {},
      revenueAfterTax: {},
      bookingType: {}
    }

    for (let baseOrderElement of salesDtoList) {
      for (let key of keys) {
        if (!cache[key]![baseOrderElement[key] as string])
          cache[key]![baseOrderElement[key] as string] = 0
        cache[key]![baseOrderElement[key] as string] += valueFn(baseOrderElement);
      }
    }

    for (let key of keys) {
      this.dataCache[key] = Object.entries(cache[key]!).map(([id, value]) => ({id, value}));

      // sort by value
      this.dataCache[key]!.sort((a, b) => b.value - a.value);
    }


  }
}
